import React from 'react';

const Footer = ({ className = '', style = {} }) => {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      href: 'https://etcmc.org/',
      label: 'Main',
    },
    {
      href: 'https://status.etcmc.org/',
      label: 'Status',
    },
  ];

  return (
    <footer className={`bg-gradient-to-r from-gray-900/80 to-gray-800/80 backdrop-blur-lg border-t border-white/10 py-8 px-4 ${className}`} style={style}>
      <div className="container mx-auto">
        <div className="text-center">
          <div className="mb-6">
            <h3 className="text-xl font-bold bg-gradient-to-r from-green-400 via-blue-500 to-purple-600 bg-clip-text text-transparent mb-2">
              ETCMC License V2 Marketplace
            </h3>
            <p className="text-gray-400 text-sm">
              © {currentYear} All rights reserved
            </p>
          </div>
          
          <div className="flex justify-center gap-6 mb-6">
            {footerLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-300 bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg transition-all duration-200 hover:bg-white/10 hover:text-white hover:scale-105"
              >
                <span className="mr-2">{link.label === 'Main' ? '🌐' : '📊'}</span>
                {link.label}
              </a>
            ))}
          </div>

          <div className="flex justify-center items-center gap-4 text-gray-500 text-xs">
            <span>Powered by</span>
            <span className="text-blue-400">ETCMC</span>
            <span>•</span>
            <span className="text-green-400">Ethereum Classic</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
